module.exports = __webpack_public_path__ + "static/ShaoYang.7ad4383d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/testimonials/ShaoYang.png
// module id = 1514
// module chunks = 35783957827783